// Make qr-code-styling's SVG open with its logo in design apps.
// The library embeds the logo in whatever format it was uploaded (the PGP
// gates are WebP) through the SVG 2 `href` attribute. Browsers show that, but
// InDesign, Illustrator, Corel and Office read only `xlink:href` and only
// PNG/JPEG, so the logo silently goes missing there.

const XLINK_NS = 'http://www.w3.org/1999/xlink';
const PORTABLE_IMAGE = /^data:image\/(png|jpe?g);/i;

// Redraw any image as a PNG data URI at its own pixel size.
export function imageToPngDataUrl(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext('2d').drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Could not load the QR logo'));
    img.src = src;
  });
}

export async function makeSvgPortable(svgText, toPng = imageToPngDataUrl) {
  const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
  // Declared up front, or the serializer invents a prefix like ns1:href.
  doc.documentElement.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', XLINK_NS);
  for (const image of Array.from(doc.getElementsByTagName('image'))) {
    let href = image.getAttribute('href') || image.getAttributeNS(XLINK_NS, 'href');
    if (!href) continue;
    if (!PORTABLE_IMAGE.test(href)) href = await toPng(href);
    image.setAttribute('href', href);
    image.setAttributeNS(XLINK_NS, 'xlink:href', href);
  }
  return new XMLSerializer().serializeToString(doc);
}
